module.exports = __webpack_public_path__ + "img/spin_btn.a1ba8394.png";